declare global {
    interface Window {
        Featurebase: (((...args: unknown[]) => void) | undefined) & { q?: Array<unknown> };
    }
}

export function featurebaseAuthenticate(
    params: {
        accountId: number;
        firstName: string;
        lastName: string;
        email?: string;
        id: number;
        featurebaseUserHash?: string;
        companyId?: number;
        companyName?: string;
    }
) {
    if (typeof window.Featurebase !== "function") {
        window.Featurebase = function (...args: unknown[]) {
            (window.Featurebase.q = window.Featurebase.q || []).push(args);
        };
    }

    window.Featurebase(
        "identify",
        {
            organization: "pentacode",
            id: params.accountId.toString(),
            name: `${params.firstName.slice(0, 1)}. ${params.lastName}`,
            email: params.email,
            userHash: params.featurebaseUserHash,
            customFields: {
                fullName: params.firstName + " " + params.lastName,
            },
            companies: [
                {
                    id: params.companyId?.toString(),
                    name: `${params.companyName} (${params.companyId})`,
                },
            ],
        },
        (err: unknown) => {
            if (err) {
                console.error(err);
            }
        }
    );
}
